import { render, staticRenderFns } from "./MealType.vue?vue&type=template&id=75dfcf55&scoped=true"
import script from "./MealType.vue?vue&type=script&lang=js"
export * from "./MealType.vue?vue&type=script&lang=js"
import style0 from "./MealType.vue?vue&type=style&index=0&id=75dfcf55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75dfcf55",
  null
  
)

export default component.exports